/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 12:40:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 14:13:38
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/PreConfig/SalesChannel/tools.ts
 */
import {
  formatLocaleSalesChannel,
  //getProduct,
} from 'src/tools/helper';
const convertSalesChannelsFromSever = ({
  channels: oriChannels,
  hasConvertToLocales = true,
}) => {
  //没有整理locale
  let channels = oriChannels || [];
  if (!hasConvertToLocales) {
    channels = formatLocaleSalesChannel({ channels, localeSupply: {} });
  }
  const mappedChannels = channels.reduce((pre, now) => {
    const { channelType } = now || {};
    if (pre[channelType]) {
      (pre[channelType] || []).push(now);
    } else {
      pre[channelType] = [now];
    }
    return pre;
  }, {});
  const re = Object.keys(mappedChannels).map((key) => {
    const _children = mappedChannels[key];

    const children = _children.map((i) => {
      const {
        //locales,
        name,
        uuid,
      } = i;
      return {
        label: name,
        value: uuid,
      };
    });
    const label = key;
    const value = key;
    return { value, label, children };
  });
  return re;
};
export { convertSalesChannelsFromSever };
